import {Environment, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import * as tracking from '../../tracking';
import {trackAndCommitMutation} from '../../tracking/amplitude/TrackMutation';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';
import {
	UpdateCustomFieldDefinitionInput,
	UpdateCustomFieldDefinitionMutation,
} from './__generated__/UpdateCustomFieldDefinitionMutation.graphql';
import type {Disposable} from 'relay-runtime';

const mutation = graphql`
	mutation UpdateCustomFieldDefinitionMutation($input: UpdateCustomFieldDefinitionInput!) {
		updateCustomFieldDefinition(input: $input) {
			customFieldDefinition {
				node {
					id
					key
					type
					displayName
					readOnly
					entityType
					avaRef
				}
			}
		}
	}
`;

function getOptimisticResponse(input: UpdateCustomFieldDefinitionInput) {
	return {
		updateCustomFieldDefinition: {
			customFieldDefinition: {
				node: {
					id: input.id,
					key: undefined,
					type: undefined,
					displayName: input.displayName,
					readOnly: input.readOnly,
					entityType: undefined,
					avaRef: input.avaRef,
				},
			},
		},
	};
}
function commit(
	environment: Environment,
	input: MutationInput<UpdateCustomFieldDefinitionInput>,
	onSuccess: RelayOnCompleted<UpdateCustomFieldDefinitionMutation>,
	onError: RelayOnError
): Disposable {
	tracking.trackEvent('CustomFieldDefinition - Updated');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: [],
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
